var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import classNames from "classnames";
import React, { useState, useCallback, useEffect } from "react";
import { hamburgerCls, hamburgerBlackCls, hamburgerLineCls } from "./Hamburger.less";
function Hamburger(_ref) {
  var _ref$theme = _ref.theme, theme = _ref$theme === void 0 ? "white" : _ref$theme, isOpened = _ref.isOpened, hamburgerHandler = _ref.hamburgerHandler;
  var _useState = useState(isOpened), _useState2 = _slicedToArray(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
  var handleClick = useCallback(function(e) {
    hamburgerHandler(e, !isActive);
    setIsActive(!isActive);
  }, [isActive, hamburgerHandler]);
  useEffect(function() {
    setIsActive(isOpened);
  }, [isOpened]);
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */ React.createElement("span", {
      role: "button",
      tabIndex: "-1",
      className: classNames(hamburgerCls, theme === "black" && hamburgerBlackCls),
      onClick: handleClick
    }, /* @__PURE__ */ React.createElement("span", {
      className: hamburgerLineCls
    }), /* @__PURE__ */ React.createElement("span", {
      className: hamburgerLineCls
    }), /* @__PURE__ */ React.createElement("span", {
      className: hamburgerLineCls
    }))
  );
}
__name(Hamburger, "Hamburger");
export {
  Hamburger
};
